import React, { useState, useEffect } from 'react';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

export default function DashboardReachedPopulation(props) {
    const [percent, setPercent] = useState(0);
    const [spend, setSpend] = useState(0);
    const [impact, setImpact] = useState(0);

    useEffect(() => {
        calculateImpact();
    }, []);
    useEffect(() => {
        calculateImpact();
    }, [percent, spend, props.totalSocialReach]);

    const calculateImpact = () => {
        const res = ((props.totalSocialReach * percent) / 100) * spend * 1000;
        setImpact(props.format(res));
    };

    return (
        <div className="card border-0 rounded-15px bg-white shadow h-100 px-3">
            <div className="card-body card-widget">
                <div className={'row'}>
                    <div className={'col'}>
                        <div className={'text-dark-blue'}>
                            <form className="form-inline">
                                <span className={'font-weight-bold'}>{$t('If')}</span>
                                <span className="input-group mx-1 px-3">
                                    <input
                                        className={'form-control'}
                                        style={{ width: '50px' }}
                                        type={'number'}
                                        value={percent}
                                        min="0"
                                        max="100"
                                        onChange={(e) => {
                                            setPercent(e.target.value);
                                        }}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text px-2" id="basic-addon1">
                                            %
                                        </span>
                                    </div>
                                </span>
                                <span className={'font-weight-bold'}> {$t("of the 'reached population' visit the host country and spent an average $")}</span>
                                <span className="input-group mx-1 px-3">
                                    <input
                                        className={'form-control'}
                                        style={{ width: '50px' }}
                                        type={'number'}
                                        value={spend}
                                        onChange={(e) => {
                                            setSpend(e.target.value);
                                        }}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text px-2" id="basic-addon1">
                                            k
                                        </span>
                                    </div>
                                </span>
                                <span className={'font-weight-bold'}> {$t('it would generate an')} </span>
                                <span className="input-group mx-1 px-3">
                                    <NumberFormat thousandSeparator={true} inputMode="numeric" className={'form-control'} value={impact} disabled={true} />
                                </span>
                                <span className={'font-weight-bold'}> {$t('amount of economic impact.')}</span>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
